module.exports = __webpack_public_path__ + "img/04.f121f737.png";